import React, {useEffect} from 'react';
import '../style/css/components/Sobre.css';
import '../style/css/components/Timeline.css';
import imgLucas from '../img/lp-2024.png';
import Breadcrumb from "./Breadcrumb";
import {staggeredFadeInDivEffect} from "./staggeredFadeInDivEffect";
import {BackToTop} from "./BackToTop";

function Sobre(){

	useEffect(()=>{
		BackToTop();
		staggeredFadeInDivEffect(50)
	})

	let experienciaProfissional = [
		{
			periodo: 'Fevereiro/2015 - Novembro/2015',
			instituicao: 'FácilPrint',
			localidade: 'Niterói - RJ',
			funcao: 'Designer Gráfico Junior',
			homeoffice: '',
			tecnologias: [
				'Adobe Illustrator',
				'Adobe Photoshop',
				'Adobe InDesign'
			]
		},
		{
			periodo: 'Novembro/2015 - Dezembro/2016',
			instituicao: 'SixHandsDesign',
			localidade: 'São Gonçalo - RJ',
			funcao: 'Web Designer Junior',
			homeoffice: '',
			tecnologias: [
				'HTML5',
				'CSS3'
			]
		},
		{
			periodo: 'Janeiro/2016 - Novembro/2016',
			instituicao: 'ML Digital Arts',
			localidade: 'São Gonçalo - RJ',
			funcao: 'Front-End e UI/UX Designer Junior',
			homeoffice: '',
			tecnologias: [
				'HTML5',
				'CSS3',
				'JavaScript',
				'Adobe Illustrator',
				'Adobe Photoshop',
			]
		},
		{
			periodo: 'Novembro/2016 - Fevereiro/2018',
			instituicao: 'Medilab Sistemas',
			localidade: 'Tijuca - RJ',
			funcao: 'Front-End e UI/UX Designer Junior',
			homeoffice: '',
			tecnologias: [
				'HTML5',
				'CSS3',
				'JavaScript',
				'Adobe Illustrator',
				'Adobe Photoshop',
				'Adobe InDesign'
			]
		},
		{
			periodo: 'Fevereiro/2018 - Fevereiro/2019',
			instituicao: 'GM5 Informática',
			localidade: 'Barra da Tijuca - RJ',
			funcao: 'Desenvolvedor Front-End Junior',
			homeoffice: '',
			tecnologias: [
				'HTML5',
				'CSS3',
				'Less CSS',
				'JavaScript',
				'jQuery',
				'PHP',
				'WordPress',
				'Lumis'
			]
		},
		{
			periodo: 'Março/2019 - Fevereiro/2021',
			instituicao: 'Eleven Consultoria',
			localidade: 'Niterói - RJ',
			funcao: 'Desenvolvedor Fullstack Pleno',
			homeoffice: ' - Home office',
			tecnologias: [
				'HTML5',
				'CSS3',
				'Less CSS',
				'JavaScript',
				'PHP',
				'MySql',
				'Microsoft SQL Server',
				'WordPress',
				'Totvs RM',
				'Vtiger CRM',
				'Laravel',
				'Linux Ubuntu'
			]
		},
		{
			periodo: 'Fevereiro/2021 - Junho/2021',
			instituicao: 'GM5 Informática',
			localidade: 'Barra da Tijuca - RJ',
			funcao: 'Desenvolvedor Back-End Pleno',
			homeoffice: ' - Home office',
			tecnologias: [
				'HTML5',
				'Sass CSS',
				'PHP',
				'MySql',
				'Laravel',
				'Linux Ubuntu',
				'WSL'
			]
		},
		{
			periodo: 'Junho/2021 - Julho/2025',
			instituicao: 'Mesha Technology',
			localidade: 'Maceió - AL',
			funcao: 'Fullstack Engineer Pleno',
			homeoffice: ' - Home office',
			tecnologias: [
				'Laravel',
				'MySql',
				'Linux Ubuntu',
				'WSL',
				'Docker',
				'JavaScript',
				'Next.js',
				'React',
				'Sass CSS',
			]
		},
		{
			periodo: 'Agosto/2025 - até o momento',
			instituicao: 'Vertigo',
			localidade: 'Rio de Janeiro - RJ',
			funcao: 'Fullstack Engineer Pleno',
			homeoffice: ' - Home office',
			tecnologias: [
				'Laravel',
				'MySql',
				'Linux Ubuntu',
				'WSL',
				'Docker',
				'JavaScript',
				'Next.js',
				'React',
				'Angular',
				'Sass CSS',
				'WordPress',
				'Drupal',
				'JHipster',
			]
		},
	];
	let cursos = [
		{
			nome: 'Design Gráfico',
			instituicao: 'Seven Escola Digital (RedZero)',
			periodo: '2012 - 2014'
		},
		{
			nome: 'Front-End',
			instituicao: 'COTI Informática',
			periodo: 'Junho/2014 - Dezembro/2015'
		},
		{
			nome: 'Web Design',
			instituicao: 'COTI Informática',
			periodo: 'Março/2015 - Maio/2015'
		},
		{
			nome: 'PHP + MySQL + Ajax',
			instituicao: 'COTI Informática',
			periodo: 'Maio/2015 - Junho/2015'
		},
		{
			nome: 'PHP e MySQL',
			instituicao: 'Hcode/Udemy',
			periodo: '2018'
		},
		{
			nome: 'MVC no PHP',
			instituicao: 'Alura',
			periodo: '2020'
		},
		{
			nome: 'Laravel',
			instituicao: 'Alura',
			periodo: '2020'
		},
		{
			nome: 'Design Patterns em PHP',
			instituicao: 'Alura',
			periodo: '2021'
		},
		{
			nome: 'React',
			instituicao: 'Alura',
			periodo: '2021'
		},
	];

	return (
		<div className='fade-enter'>
			<Breadcrumb page='Sobre mim'/>

			<h1 className='fade-enter'>Sobre mim</h1>

			<div className="row">
				<div className="col">
					<div className="fade-enter">
						<div className="imgWrapp">
							<img src={imgLucas} alt="Lucas Pedro" loading='lazy' />
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col">
					<div className="card card_Exp_Cursos fade-enter">
						<div className="container">
							<div className="row">

								<div className="col-12 fade-enter">
									<h3 className='pageTitle'>Quem é o Lucas?</h3>
									<hr/>
									<div className="fade-enter">
										<p className="text_WhoAmI">
											Desenvolvedor Fullstack com +10 anos de experiência, especializado em transformar sistemas legados complexos em soluções escaláveis e de alta performance, com impacto direto em eficiência e receita.
										</p>
										<p className="text_WhoAmI">
											Especialista em todo o ciclo de desenvolvimento: da arquitetura back-end (Laravel, PHP, Redis) à entrega front-end performática (React, Next.js), com práticas maduras de CI/CD, testes automatizados e DevOps (Docker, AWS).
										</p>
										<p className="text_WhoAmI">
											Fluente em utilização de metodologias favoráveis ao uso de IA para produtividade e qualidade na entrega.
										</p>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-12">
					<div className="card fade-enter">
						<div className="row">
							<div className="col-12 fade-enter">
								<h3 className="pageTitle">Carreira</h3>
								<hr/>
							</div>
							<div className="col-12">
								<div className="row">
									<div className="col col-md-6">
										<div className="card card_Exp_Cursos fade-enter">
											<div className="container">
												<div className="row">

													<div className="col-12 fade-enter">
														<h3 className='pageTitle'>Experiência Profissional</h3>
													</div>

													<div className="col-12 fade-enter">
														<div className="rightbox">
															<div className="rb-container">
																<ul className="rb">
																	{
																		experienciaProfissional.reverse().map((item, index) => {
																			return (
																				<li className="rb-item" ng-repeat="itembx" key={index}>
																					<h4>{item.funcao}</h4>
																					<div className="timestamp">
																						Período:
																						<br/>
																						{item.periodo}
																					</div>
																					<div className="item-title">
																						<p>
																							<strong>Instituição: </strong>{item.instituicao} <small>({item.localidade}){item.homeoffice}</small>
																						</p>
																						<p>
																							<strong>Tecnologias utilizadas: </strong>
																							<br/>
																							{
																								item.tecnologias.map((stack, indexStack) => {
																									return (
																										<span className='badgeTech' key={indexStack}>{stack}</span>
																									);
																								})
																							}
																						</p>
																					</div>
																				</li>
																			)
																		})
																	}
																</ul>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>
									<div className="col col-md-6">
										<div className="card card_Exp_Cursos fade-enter">
											<div className="container">
												<div className="row">

													<div className="col-12 fade-enter">
														<h3 className='pageTitle'>Educação</h3>
													</div>

													<div className="col-12 fade-enter">
														<div className="rightbox">
															<div className="rb-container">
																<ul className="rb">
																	{
																		cursos.reverse().map((item, index) => {
																			return (
																				<li className="rb-item" ng-repeat="itembx" key={index}>
																					<h4>{item.nome}</h4>
																					<div className="timestamp">
																						Período:
																						<br/>
																						{item.periodo}
																					</div>
																					<div className="item-title">
																						<p>
																							<strong>Instituição: </strong>{item.instituicao}
																						</p>
																					</div>
																				</li>
																			)
																		})
																	}
																</ul>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	);
}

export default Sobre;
